import Vue from 'vue'
import CheckoutWizard from './CheckoutWizard'

const VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);

Vue.config.productionTip = true

new Vue({
  el: '#checkout',
  components: {
    CheckoutWizard
  }
})